import axios, { AxiosError, AxiosInstance, AxiosResponse } from "axios";

type ApiErrorBody = { message?: unknown };

export function apiErrorMessage(error: unknown, fallback: string) {
  if (!axios.isAxiosError<ApiErrorBody>(error)) return fallback;
  const message = error.response?.data?.message;
  return typeof message === "string" && message.trim() ? message : fallback;
}

export const BASE_URL = "/api/backend/";

const apiClient: AxiosInstance = axios.create({
  baseURL: BASE_URL,
  timeout: 15_000,
  withCredentials: true,
});

function handleError(error: AxiosError) {
  console.error("API 호출 중 오류 발생:", {
    method: error.config?.method?.toUpperCase(),
    url: error.config?.url,
    status: error.response?.status,
    message: error.message,
  });
}

async function unwrap<T>(request: Promise<AxiosResponse<T>>): Promise<T> {
  try {
    return (await request).data;
  } catch (error) {
    handleError(error as AxiosError);
    throw error;
  }
}

export const getRequest = <T>(endpoint: string, params?: object) =>
  unwrap(apiClient.get<T>(endpoint, { params }));
export const postRequest = <T, U>(endpoint: string, data: U) =>
  unwrap(apiClient.post<T>(endpoint, data));
export const putRequest = <T, U>(endpoint: string, data: U) =>
  unwrap(apiClient.put<T>(endpoint, data));
export const patchRequest = <T, U>(endpoint: string, data: U) =>
  unwrap(apiClient.patch<T>(endpoint, data));
export const deleteRequest = <T>(endpoint: string) =>
  unwrap(apiClient.delete<T>(endpoint));
export async function downloadRequest(endpoint: string, filename: string) {
  const response = await apiClient.get<Blob>(endpoint, { responseType: "blob" });
  const url = URL.createObjectURL(response.data);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}
export const GetDateOnly = (date: Date) =>
  `${date.getUTCFullYear()}-${String(date.getUTCMonth() + 1).padStart(2, "0")}-${String(date.getUTCDate()).padStart(2, "0")}`;

export default apiClient;
